module.exports = __webpack_public_path__ + "img/badge-list-thumb-064.795f0756.png";